import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentPillComponent } from 'ng2-app/components/document-pill/document-pill.component';
import { BytesModule } from 'ng2-app/pipes/bytes/bytes.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  imports: [
    CommonModule,
    BytesModule,
    MatTooltipModule,
  ],
  declarations: [
      DocumentPillComponent
  ],
  exports: [
      DocumentPillComponent
  ]
})
export class DocumentPillModule { }
